import User from './user';
import Error from './error';
import States from './states';
import Counties from './counties';
import Courts from './courts';
import Departments from './departments';
import CaseTypes from './caseTypes';
import CaseForm from './caseForm';
import PriceForm from "./priceForm";
import Case from './case';
import Cases from './cases';
import CaseSubTypes from './caseSubTypes';
import UserRegisterForm from "./userRegisterFrom";
import UserLoginForm from "./userLoginFrom";
import CreditCardForm from "./creditCardForm";
import Layout from "./layout";
import Modals from "./modal";
import UserEditForm from "./userEditFrom";
import ChangePasswordForm from "./changePasswordForm";
import Documents from "./documents";
import ForgotPasswordForms from "./forgotPassword";
import LocationForm from "./locationForm"
import DateTime from "./dateTime"

const Reducers = {
    User,
    Error,
    States,
    Counties,
    Courts,
    Departments,
    CaseTypes,
    CaseForm,
    PriceForm,
    CaseSubTypes,
    UserRegisterForm,
    CreditCardForm,
    Case,
    UserLoginForm,
    Layout,
    Cases,
    Modals,
    UserEditForm,
    ChangePasswordForm,
    Documents,
    ForgotPasswordForms,
    LocationForm,
    DateTime
};
export default Reducers;
